import type { ReactNode } from "react";

import { cn } from "../utils";
import { NcLoadingIndicator, type NcLoadingIndicatorProps } from "./nc-loading-indicator";

type NcLoadingOverlayProps = NcLoadingIndicatorProps & {
  children?: ReactNode;
  isLoading?: boolean;
};

export const NcLoadingOverlay = ({
  variant,
  isLoading,
  children,
  className,
  ...props
}: NcLoadingOverlayProps) => (
  <div
    data-nc="NcLoadingOverlay"
    className={cn("relative min-h-[1.5em]", className)}
    aria-live="polite"
    aria-busy={isLoading}
    {...props}
  >
    {children}
    {isLoading && (
      <div className="bg-light/80 absolute inset-0 grid place-items-center transition-opacity duration-750 ease-in-out starting:opacity-0">
        <NcLoadingIndicator
          className="transition-opacity delay-500 duration-1000 starting:opacity-0"
          variant={variant}
        />
      </div>
    )}
  </div>
);
